<template>
  <notifications :max="3" class="my-2"/>
</template>
